"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHash = void 0;
const types_1 = require("@requestnetwork/types");
const utils_1 = require("@requestnetwork/utils");
const getHash = (curr) => {
    return curr.type === types_1.RequestLogicTypes.CURRENCY.ERC20 ||
        curr.type === types_1.RequestLogicTypes.CURRENCY.ERC777
        ? curr.value
        : (0, utils_1.last20bytesOfNormalizedKeccak256Hash)({
            type: curr.type,
            value: curr.value,
            // FIXME network should be included for native tokens.
            // This implies an admin update on the conversion contract
            // Needs to be done before supporting ETH conversion on other chains than mainnet
            // network: 'network' in curr ? curr.network : undefined,
        });
};
exports.getHash = getHash;
